import { ArrowBack } from '@mui/icons-material';
import React from 'react';
import COLOR from 'utils/constants/color';
import styled from "styled-components";
const ButtonWrapper = styled.button`
    background-color: ${COLOR.indigo200};
    width: max-content;
    color: ${COLOR.white};
    border: none;
    outline: none;
    padding: 5px 0px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-left: 8px;
    padding-right: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    @media (max-width: 450px) {
        padding-left: 0px;
    padding-right: 3px;
    }
   `
export const BackButtonEbook = ({ onClick, label  , style={}}) => {
    return (
        <ButtonWrapper className='text-wrap min-w-50px' style={{ marginRight: "1.5px", whiteSpace: "nowrap", display: "flex", alignItems: "center", padding: "8px" , ...style }} onClick={onClick}>
            <ArrowBack style={{ fontSize: '14px', marginRight: '4px' }} />
            {label ? label : "Back"}
        </ButtonWrapper>
    );
};